export default {
  SET_drawer(state, payload) {
    state.drawer = payload
  },
}
